/**
 * @file routes/_app/settings/laboratories.tsx
 * @description 「業務字典 — 實驗室管理」維護頁路由。
 */
import { createFileRoute } from '@tanstack/react-router';
import { LaboratoriesPage } from '@/components/settings/LaboratoriesPage';

export const Route = createFileRoute('/_app/settings/laboratories')({
  component: LaboratoriesPage,
});
